export const DISCORD_CLIENT_ID = "528891626295132161"
export const GITHUB_CLIENT_ID = "6b9072f5c1e40b155a66"
export const GOOGLE_CLIENT_ID = "92938710216-meflm3ri0ihbtlrhqspm5pls67af5al3.apps.googleusercontent.com"

const WAN_TLD = "xyz" as const;
const LOCAL_TLD = "local" as const;
export const isLive = window.location.hostname.endsWith(WAN_TLD)
export const isDev = !isLive

const TLD = isLive ? WAN_TLD : LOCAL_TLD
export const GAME_SERVER_URL = `wss://tiseno.${TLD}/ws` as const
export const API_URL = `https://tiseno.${TLD}` as const
export const REDIRECT_URL = `https://tiseno.${TLD}/redirect` as const
